module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmWUlfChc4EsA.deb26e9b.woff2";